import {forwardRef, type HTMLProps, memo} from 'react';

import classNames from 'classnames';

import SearchIcon from '@yourcoach/shared/assets/icons/search.svg';

import styles from './TextField.module.css';

interface Props extends HTMLProps<HTMLInputElement> {
  error?: null | string;
  id?: string;
  label?: string;
  type?: string;
  variant?: 'search';
}

const TextField = forwardRef<HTMLInputElement, Props>(
  ({className, disabled, error, id, label, variant, ...rest}, ref) => {
    id = id || Math.random().toString(36).substring(2);

    return (
      <div
        className={classNames(
          'TextField',
          styles.TextField,
          disabled && styles.disabled,
          variant && styles[variant],
          className,
        )}
      >
        {variant === 'search' ? (
          <div className={styles.inputContainer}>
            <input {...rest} disabled={disabled} id={id} ref={ref} />
            <SearchIcon />
          </div>
        ) : (
          <>
            <input {...rest} disabled={disabled} id={id} ref={ref} />
            {label ? <label htmlFor={id}>{label}</label> : null}
            <div
              className={styles.error}
              data-test-id={`${rest['data-test-id']}_error`}
            >
              {error}
            </div>
          </>
        )}
      </div>
    );
  },
);

export default memo(TextField);
